export default __webpack_public_path__ + "KaTeX_Main-Bold.a9cdbc850d2f94b8887ccf38fc6d6d85.woff";